import { Component, ReactNode } from 'react';

import { i18n } from 'i18n';
import { Dialog } from 'theSource/components/Dialog';
import { Button } from 'theSource/components/Button';
import { ROUTES } from 'theSource/app/routes';
import { getCompanyName } from 'theSource/utils';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      const systemErrorLabel = i18n.t('common:systemError');
      const somethingWrongLabel = i18n.t('common:somethingWrong');
      const backHomeLabel = i18n.t('common:backHome');

      const handleBackHomeClick = () =>
        window.location.assign(`/${getCompanyName()}${ROUTES.main.home.path}`);

      return (
        <Dialog
          testId="error-boundary"
          title={systemErrorLabel}
          message={somethingWrongLabel}
          showWarningIcon
          isOpen
        >
          <Button
            label={backHomeLabel}
            onClick={handleBackHomeClick}
            variant="tertiary"
          />
        </Dialog>
      );
    }

    return this.props.children;
  }
}
